 
 
import {
  clearServices,
  getServicesFail,
  getServicesStarted,
  getServicesSuccess
} from '../../../reducer/services/GetServicesReducer';
import { ServiceRequest } from '../../../sagas/services/GetServicesSaga';
import { getServices } from '../../actionType/services/GetServicesTypes';
import {
  ClearGetServices,
  GetServicesFailure,
  GetServicesFailurePayload,
  GetServicesRequest,
  GetServicesStarted,
  GetServicesSuccess,
  GetServicesSuccessPayload
} from '../../types/services/GetServiceTypes';

export const getServicesRequest = (
  reqObject: ServiceRequest
): GetServicesRequest => ({
  type: getServices.FETCH_SERVICES_REQUEST,
  requestObject: reqObject
});

/**
 * get metric summary started saga action
 * @returns get metric summary action
 */
export const getServicesStart =
  (): GetServicesStarted => ({
    type: getServicesStarted.type
  });

/**
 * Get metric summary success saga action
 * @param payload :Metric data
 * @returns success action
 */
export const getServicesSuccessful = (
  payload: GetServicesSuccessPayload
): GetServicesSuccess => ({
  type: getServicesSuccess.type,
  payload
});

/**
 * get metric Failed saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const getServicesFailure = (
  payload: GetServicesFailurePayload
): GetServicesFailure => ({
  type: getServicesFail.type,
  payload
});

/**
 * Clear metrics saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const cleargetServices =
  (): ClearGetServices => ({
    type: clearServices.type
  });
